"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detailSchema = void 0;
exports.detailSchema = {
    type: 'object',
    required: [
        'additionalNote',
        'approvedLenderName',
        'approvedLenderTransitNumber',
        'firstAuthorizedOfficerName',
        'lenderAddressLineOneDescription',
        'lenderAddressMunicipalityName',
        'lenderAddressPostalCode',
        'lenderAddressProvinceName',
        'recordSentUserEmailID',
        'recordSentUserName',
        'recordSentUserTelephoneNumber',
        'recordSentUserTitleName',
    ],
    properties: {
        additionalNote: {
            type: 'string',
            minLength: 0,
            maxLength: 1000,
            errorMessage: 'should have maximum length of 1000 characters',
        },
        approvedLenderName: {
            type: 'string',
            minLength: 1,
            maxLength: 35,
            errorMessage: 'Should be a string with a maximum of 35 characters',
        },
        approvedLenderTransitNumber: {
            type: 'string',
            minLength: 5,
            maxLength: 5,
            errorMessage: 'Should be a string with 5 characters',
        },
        firstAuthorizedOfficerName: {
            type: 'string',
            minLength: 1,
            maxLength: 35,
            errorMessage: 'Should be a string with a maximum of 35 characters or null',
        },
        lenderAddressLineOneDescription: {
            type: 'string',
            minLength: 1,
            maxLength: 90,
            errorMessage: 'Should be a string with a maximum of 90 characters',
        },
        lenderAddressLineTwoDescription: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 90,
            errorMessage: 'Should be a string with a maximum of 90 characters or null',
        },
        lenderAddressMunicipalityName: {
            type: 'string',
            minLength: 1,
            maxLength: 20,
            errorMessage: 'Should be a string with a maximum of 20 characters',
        },
        lenderAddressPostalCode: {
            type: 'string',
            minLength: 6,
            maxLength: 6,
            errorMessage: 'Should be a string with 6 characters',
        },
        lenderAddressProvinceName: {
            type: 'string',
            minLength: 1,
            maxLength: 30,
            errorMessage: 'Should be a string with a maximum of 30 characters',
        },
        recordSentUserDepartmentName: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 64,
            errorMessage: 'Should be a string with a maximum of 64 characters',
        },
        recordSentUserEmailID: {
            type: 'string',
            minLength: 1,
            maxLength: 80,
            errorMessage: 'Should be a string with a maximum of 80 characters',
        },
        recordSentUserFaxNumber: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 10,
            errorMessage: 'Should be a string with a maximum of 10 characters',
        },
        recordSentUserName: {
            type: 'string',
            minLength: 1,
            maxLength: 41,
            errorMessage: 'Should be a string with a maximum of 41 characters',
        },
        recordSentUserSectorName: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 256,
            errorMessage: 'Should be a string with a maximum of 256 characters',
        },
        recordSentUserTelephoneNumber: {
            type: 'string',
            minLength: 1,
            maxLength: 10,
            errorMessage: 'Should be a string with a maximum of 10 characters',
        },
        recordSentUserTitleName: {
            type: 'string',
            minLength: 1,
            maxLength: 128,
            errorMessage: 'Should be a string with a maximum of 128 characters',
        },
    },
};
